import { Filter } from 'interweave';

const tags = {
	'[%YY]': (new Date()).getFullYear().toString().substr(-2),
	'[%YYYY]': (new Date()).getFullYear()
}

class ShortTagFilter extends Filter {
	node(name, node) {
		let html = node.innerHTML
		const regex = /\[%[A-Z]+\]/g
		const matches = html.match(regex)
		if (matches) {
			matches.forEach(match => {
				html = html.replace(`${match}`, tags[match] || '')
			})
		}
		node.innerHTML = html
		return node;
	}
}

export default ShortTagFilter


// WEBPACK FOOTER //
// ./src/components/ContentNode/filters/ShortTagFilter.js